'use client';

import dynamic from 'next/dynamic';
import type { PropsWithChildren, ReactNode } from 'react';
import { Spinner } from './Spinner/Spinner';

function NoSsr({ children }: PropsWithChildren): ReactNode {
	// TODO: Should we wrap with suspense so that things like query parameters are ready?
	return <>{children}</>;
}

export default dynamic(async () => Promise.resolve(NoSsr), {
	ssr: false,
	loading: () => <Spinner />,
});
